package nl.volleyplanner.types

import kotlinx.serialization.Serializable

enum class Gender {
    Men, Women, Mixed
}

data class SportType(
    val name: String
)

@Serializable
data class AgeGroup(
    val identifier: String,
    val label: String,
    val ageFrom: Int,
    val ageTo: Int
) : Comparable<AgeGroup> {
    fun isInAgeRange(age: Int) : Boolean {
        return age in ageFrom..< ageTo
    }

    override fun compareTo(other: AgeGroup): Int {
        return compareValuesBy(this, other, { it.ageFrom }, { it.ageTo } , { it.identifier })
    }
}